import { Box, Flex, Text } from '@chakra-ui/react'
import { HeaderCard } from './components/HeaderCard'
import { FiAlertCircle } from 'react-icons/fi'
import { Card } from './components/Card'
import { RoundedNumber } from './components/RoundedNumber'

export function Pendencias({ infoCustomer, codCustomerSelected, isLoading }) {
  return (
    <Box w="513px">
      <HeaderCard title="Pendências" icon={<FiAlertCircle size={24} color="#2D2D2D" />} />

      <Card mt={2} py={'40px'} display="flex" alignItems="center" justifyContent="space-between" isLoading={isLoading}>
        <Flex flexDir="column" gap={2} alignItems="center">
          <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold">
            do dia
          </Text>
          <RoundedNumber
            number={infoCustomer?.pendencias_dia}
            color="#FF0000"
            bgColor="#F5F5F5"
            w="47px"
            h="47px"
            fontSize="23px"
            to={`/propostas/${codCustomerSelected}?pendentes_dia=true`}
          />
        </Flex>
        <Flex flexDir="column" gap={2} alignItems="center">
          <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold">
            Atrasadas
          </Text>
          <RoundedNumber
            number={infoCustomer?.pendencias_atrasadas}
            color="#FF0000"
            bgColor="#F5F5F5"
            w="47px"
            h="47px"
            fontSize="23px"
            to={`/propostas/${codCustomerSelected}?pendencias_atrasadas=true`}
          />
        </Flex>

        <Flex flexDir="column" gap={2} alignItems="center">
          <Text fontSize="12px" color="#2d2d2d" textTransform="uppercase" fontWeight="semibold">
            Chamado Novo Atrasado
          </Text>
          <RoundedNumber
            number={infoCustomer?.pendencias_novo}
            color="#FF0000"
            bgColor="#F5F5F5"
            w="47px"
            h="47px"
            fontSize="23px"
            to={`/propostas/${codCustomerSelected}?pendencia_novo=true`}
          />
        </Flex>
      </Card>
    </Box>
  )
}
